import React from "react";
import { AdminTabs } from "../../../components/ui";

const DEFAULT_TABS = [
  { id: "overview", label: "Overview" },
  { id: "results", label: "Results" },
  { id: "battles", label: "Battle Log" },
  { id: "planning", label: "Planning" },
  { id: "upload", label: "Upload" },
  { id: "templates", label: "Templates" },
  { id: "analytics", label: "Analytics" },
  { id: "recommendations", label: "Player List" },
];

export default function EventsWorkspaceTabs({ activeTab, onSelect, tabs = DEFAULT_TABS }) {
  return (
    <AdminTabs
      tabs={tabs.map((tab) => ({ value: tab.id, label: tab.label }))}
      value={activeTab}
      onChange={onSelect}
      className="events-tabs events-tabs-secondary events-workspace-tabs"
      aria-label="Events workspace sections"
    />
  );
}
